import {FullScreenFader, ScreenParameters} from '@gongxigames/framework/core';
import {PopupFaderColorConfig, PopupFaderConfig} from '@gongxigames/framework/slot/types';
import {Fader, CallBack} from '@gongxigames/framework/slot/modules/genericPopup/fader/Fader';

export class FaderColor extends Fader {
    static testSettingsType(config: PopupFaderConfig): boolean {
        return (config as PopupFaderColorConfig).color !== undefined;
    }

    private fader?: FullScreenFader;
    public isFadedIn = false;

    public show(cb: CallBack): void {
        const { container, config, updater, displayObjectUtils } = this;
        const { alpha, color } = config as PopupFaderColorConfig;
        const duration = this.getFadeDuration();

        this.fader = displayObjectUtils.createFullScreenFader({ alpha: 0, color });

        container.addChild(this.fader);

        updater
            .addTween(this.fader)
            .to({ alpha }, duration)
            .onComplete(() => {
                this.isFadedIn = true;
                cb();
            })
            .start();

        this.container.visible = true;
    }

    public resize(screenParams: ScreenParameters): void {
        this.fader?.resize(screenParams);
    }
}
